import { ModalRoute } from "../../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../../Navigation/ModalTransitionSwitch";
import { FailedPayoutPage } from "./Page";

interface FailedPayoutModalRoutesProps {
  basePath: string;
}

export function FailedPayoutModalRoutes(props: FailedPayoutModalRoutesProps) {
  const { basePath } = props;

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        path={basePath}
        render={({ modalState }) => {
          return <FailedPayoutPage modalState={modalState} />;
        }}
      />
    </ModalTransitionSwitch>
  );
}
